// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"zendesk-messenger_buttonContainer__WK2WA","commentIcon":"zendesk-messenger_commentIcon__czBWN"};